import config from '../_config/config';
import { authHeader } from '../_helpers';
//console.log( config );
export const userService = {
    login,
    logout,
    signup,
    checkAuth,
    getAll,
    updateBasket,
    updateFav
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${config.apiUrl}/users/authenticate/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    console.log('logged out');
}


function signup(firstname, lastname, company, email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ firstname, lastname, company, email, password })
    };

    return fetch(`${config.apiUrl}/users/signup/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
/*
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
*/
            return user;
        });
}




function checkAuth(){
   const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${config.apiUrl}/users/checkauth/`, requestOptions).then(handleResponse);  
}


function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${config.apiUrl}/users/`, requestOptions).then(handleResponse);
}


function updateBasket(basket){
  const requestOptions = {
        method: 'PUT',
        headers: authHeader(), //{ 'Content-Type': 'application/json' },
        body: JSON.stringify({ basket })
        };
    return fetch(`${config.apiUrl}/users/basket/`, requestOptions).then(handleResponse); 
}



function updateFav(fav){
  const requestOptions = {
        method: 'PUT',
        headers: authHeader(), //{ 'Content-Type': 'application/json' },
        body: JSON.stringify({ fav })
        };
    return fetch(`${config.apiUrl}/users/fav/`, requestOptions).then(handleResponse); 
}



function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}